const organizationNameFromQueryString = () =>
  document.location.search.indexOf('org=') > -1
    ? document.location.search.replace(/\?(.*?)org=([^&]+).*/gi, '$2')
    : null;
export { organizationNameFromQueryString };
